import messages from '../../services/api/src/lib/i18n';

export default defineI18nConfig(() => ({
  legacy: false,
  globalInjection: true,
  locale: 'en',
  messages,
}));

